import React from "react";
import "../Styles/LogosSection.css";
const LARGE_LOGOS = ["VETZONE", "NARIKISAN", "YAWYE", "IPWF","YILMR","LBFTI","YTPATIL","CMPCLUB"];
export default function LogosSection({ title, images = [] }) {
  return (
    <div className="logos-section">
      <h2 className="logos-title"style={{ fontWeight: 'bold' }}>{title}</h2>
      <div className="logos-title-underline"></div>

      <div className={`logos-container ${images.length < 8 ? "few-logos" : ""}`}>
        {images.length > 0 ? (
          images.map((img, index) => (
           <img
              key={index}
              className={`Logo ${LARGE_LOGOS.includes(img.alt) ? "LargeLogo" : ""}`}
              src={img.src}
              alt={img.alt || `Logo ${index}`}
            />

          ))
        ) : (
          <p>No images to display.</p>
        )}
      </div>
    </div>
  );
}
